
import LeaveTable from "components/Tables/Leaves";

export const EmployeeLeave = ({userData}) => {
   
  return (
    <>
   

        {/* /Assests Tab */}
        <div className="tab-pane fade" id="emp_leaves" style={{ padding: window.innerWidth < 768 ? "8px 0 160px 0" : "12px 0 80px 0" }}>
            <LeaveTable userData={userData}/>
        </div>
        {/* /Bank Tab */}

      
    </>
  );
};
